module.exports = __webpack_public_path__ + "static/media/alpaca.805b16db.jpg";